export default __webpack_public_path__ + "static/media/resume.d7c2877f.pdf";